import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { borderRadius, skeletonShimmer } from '@atlaskit/theme/constants';
import { N20A } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, keyframes } from '@emotion/react';
import { grid } from '../style-utils';
var smallItemElemSpacing = grid.multiple(1.5).unitless;
var itemElemSpacing = grid.multiple(1).unitless;
var itemElemSize = grid.multiple(3).unitless;
var itemMinHeight = grid.multiple(5).unitless;
var skeletonContentHeight = grid.multiple(1.75).unitless / 2;
var shimmer = skeletonShimmer();
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var shimmerKeyframes = keyframes(shimmer.keyframes);
var isSmallAvatar = function isSmallAvatar(avatarShape) {
  return avatarShape.indexOf('small') === 0;
};
var isCircleAvatar = function isCircleAvatar(avatarShape) {
  return avatarShape.indexOf('circle') !== -1;
};
export var avatarSkeletonCSS = function avatarSkeletonCSS(avatarShape, isShimmering) {
  return _objectSpread(_objectSpread({
    // This will render a skeleton in the "elemBefore" position.
    backgroundColor: "var(--ds-skeleton, ".concat(N20A, ")")
  }, isShimmering && _objectSpread(_objectSpread({}, shimmer.css), {}, {
    animationName: "".concat(shimmerKeyframes)
  })), {}, {
    marginRight: isSmallAvatar(avatarShape) ? smallItemElemSpacing : itemElemSpacing,
    width: isSmallAvatar(avatarShape) ? '14px' : itemElemSize,
    height: isSmallAvatar(avatarShape) ? '14px' : itemElemSize,
    borderRadius: isCircleAvatar(avatarShape) ? '100%' : borderRadius(),
    flexShrink: 0,
    display: 'inline-block'
  });
};
var itemCSS = css({
  cursor: 'pointer',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
  display: 'block',
  width: '100%',
  boxSizing: 'border-box',
  backgroundColor: 'transparent',
  border: 0,
  outline: 0,
  margin: 0
});
export var labelSkeletonCSS = function labelSkeletonCSS(width, isShimmering, textHeight) {
  return _objectSpread(_objectSpread({
    // This will render the skeleton "text".
    backgroundColor: "var(--ds-skeleton, ".concat(N20A, ")")
  }, isShimmering && _objectSpread(_objectSpread({}, shimmer.css), {}, {
    animationName: "".concat(shimmerKeyframes)
  })), {}, {
    height: "".concat(textHeight ? textHeight / 2 : skeletonContentHeight, "px"),
    borderRadius: borderRadius(),
    flexBasis: width || '100%'
  });
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var itemSkeletonCSS = css([
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
itemCSS, {
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  minHeight: itemMinHeight
}]);